import { Component, OnInit, ViewChild} from '@angular/core';

import * as moment from 'moment';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { ConnectBackendService } from 'src/app/service/connect-backend.service';
import { UtityService } from 'src/app/service/utity.service';
import * as global from '../../config/globals';

@Component({
  selector: 'home',
  templateUrl: './home.html'
})

export class HomePage implements OnInit {


  stackedChartOptions;
  stackedChartData;

  barChartOptions;
  barChartData;

  donutChartOptions;
  donutChartData;

  pieChartOptions;
  pieChartData;

  pieChartDataNgx;
  pieChartColorNgx;

  chartData;
  areaChartData;
  chartColor;

  lineChartData;
  lineChartOptions;

  stackedBarChartOptions;
  stackedBarChartData;

  barChartMonthData
  barChartMonthOptions

  bestSaler = [];
  lastBillItem = [];
  inv_code: string | undefined;
  barData = [];

  sumTotal = [];
  countBill: number = 0;

  sum_profit: number = 0;
  sum_sale: number = 0;
  sum_vat: number = 0;
  cost: number = 0;

  cost_percen: number = 0;
  profit_percen: number = 0;

  graphData = [];
  sumSale_today: number = 0;
  sumCost_today: number = 0;
  sumProfit_today: number = 0;
  sumVat_today: number = 0;

  delimiter: string | undefined | null;
  url: string;

  lat = 25.304304;
  lng = -90.06591800000001;

  icon1: string | undefined | null;
  icon2: string | undefined | null;
  icon3: string | undefined | null;
  icon4: string | undefined | null;
  icon5: string | undefined | null;

  class1: string | undefined | null;
  class2: string | undefined | null;
  class3: string | undefined | null;
  class4: string | undefined | null;
  class5: string | undefined | null;

  clicked1: boolean = false;
  clicked2: boolean = false;
  clicked3: boolean = false;
  clicked4: boolean = false;
  clicked5: boolean = false;

  view: string | undefined | null;

  option : any = {
    duration: 2,
    decimalPlaces: Number(2),
  };


  sumTotalLastMonth: number = 0;
  sumTotalThisMonth: number = 0;
  diffMonth: number = 0;
  monthPercen: number = 0;

  sumTotalLastYear: number = 0;
  sumTotalThisYear: number = 0;
  diffYear: number = 0;
  yearPercen: number = 0; 


  constructor(
    private api: ConnectBackendService,
    private utity: UtityService

  ) {

    this.url = this.api.url;
  }



  ngOnInit(): void {

    this.loadBestSaller();
    this.loadLastBillSale();

    this.loadSumSalePerDay();
    this.loadDataPerDay();
    this.loadSumSalePerMonth();

    this.sum_profit = 0;
    this.sum_sale = 0;
    this.sum_vat = 0;
    this.cost = 0;
    this.view = 'lastbill';

    this.profit_percen = 0;
    this.cost_percen = 0;

    this.delimiter = localStorage.getItem('delimiter');

    this.chooseWeekly();

  }

  chooseAll(): void {

    this.clicked1 = true;
    this.clicked2 = false;
    this.clicked3 = false;
    this.clicked4 = false;
    this.clicked5 = false;

    this.icon1 = 'fa fa-check';
    this.icon2 = 'fa fa-list';
    this.icon3 = 'fa fa-list';
    this.icon4 = 'fa fa-list';
    this.icon5 = 'fa fa-list';

    this.class1 = 'btn btn-indigo';
    this.class2 = 'btn btn-info';
    this.class3 = 'btn btn-info';
    this.class4 = 'btn btn-info';
    this.class5 = 'btn btn-info';

    const condition = {
      data : 'all'
    };

    this.loadDataSum(condition);
  }

  chooseDay(): void {
    this.clicked1 = false;
    this.clicked2 = true;
    this.clicked3 = false;
    this.clicked4 = false;
    this.clicked5 = false;

    this.icon1 = 'fa fa-list';
    this.icon2 = 'fa fa-check';
    this.icon3 = 'fa fa-list';
    this.icon4 = 'fa fa-list';
    this.icon5 = 'fa fa-list';

    this.class1 = 'btn btn-info';
    this.class2 = 'btn btn-indigo';
    this.class3 = 'btn btn-info';
    this.class4 = 'btn btn-info';
    this.class5 = 'btn btn-info';

    const condition = {
      data : 'day'
    };

    this.loadDataSum(condition);
  }


  chooseWeekly(): void {

    this.clicked1 = false;
    this.clicked2 = false;
    this.clicked3 = true;
    this.clicked4 = false;
    this.clicked5 = false;

    this.icon1 = 'fa fa-list';
    this.icon2 = 'fa fa-list';
    this.icon3 = 'fa fa-check';
    this.icon4 = 'fa fa-list';
    this.icon5 = 'fa fa-list';

    this.class1 = 'btn btn-info';
    this.class2 = 'btn btn-info';
    this.class3 = 'btn btn-indigo';
    this.class4 = 'btn btn-info';
    this.class5 = 'btn btn-info';

    this.class1 = 'btn btn-info';
    this.class2 = 'btn btn-info';
    this.class3 = 'btn btn-indigo';
    this.class4 = 'btn btn-info';
    this.class5 = 'btn btn-info';

    const condition = {
      data : 'week'
    };

    this.loadDataSum(condition);
  }

  chooseMonth(): void{
    this.clicked1 = false;
    this.clicked2 = false;
    this.clicked3 = false;
    this.clicked4 = true;
    this.clicked5 = false;

    this.icon1 = 'fa fa-list';
    this.icon2 = 'fa fa-list';
    this.icon3 = 'fa fa-list';
    this.icon4 = 'fa fa-check';
    this.icon5 = 'fa fa-list';

    this.class1 = 'btn btn-info';
    this.class2 = 'btn btn-info';
    this.class3 = 'btn btn-info';
    this.class4 = 'btn btn-indigo';
    this.class5 = 'btn btn-info';

    const condition = {
      data : 'month'
    };

    this.loadDataSum(condition);
  }

  chooseYears(): void {

    this.clicked1 = false;
    this.clicked2 = false;
    this.clicked3 = false;
    this.clicked4 = false;
    this.clicked5 = true;

    this.icon1 = 'fa fa-list';
    this.icon2 = 'fa fa-list';
    this.icon3 = 'fa fa-list';
    this.icon4 = 'fa fa-list';
    this.icon5 = 'fa fa-check';

    this.class1 = 'btn btn-info ';
    this.class2 = 'btn btn-info';
    this.class3 = 'btn btn-info';
    this.class4 = 'btn btn-info';
    this.class5 = 'btn btn-indigo';

    const condition = {
      data : 'year'
    };

    this.loadDataSum(condition);
  }


  chooseLastBill(): void {
    this.view = 'lastbill';
  }

  async chooseGrowup(){
    this.view = 'growup';

    this.sumTotalLastMonth  = 0;
    this.sumTotalThisMonth = 0;
    this.diffMonth = 0;
    this.monthPercen = 0;

    this.sumTotalLastYear = 0;
    this.sumTotalThisYear = 0;
    this.diffYear = 0;
    this.yearPercen = 0;

    this.sumTotalLastYear = 0;
    this.sumTotalThisYear = 0;
    this.diffYear = 0;
    this.yearPercen = 0;

    this.sumTotalThisMonth = this.sumSale_today;

    const sumThisMonth =  await this.api.get('/report/loadGrowUpPresend').toPromise();
    this.sumTotalThisYear = sumThisMonth.sum_sale;

    const sumLastMonth = await this.api.get('/report/loadGrowUpPart').toPromise();
    this.sumTotalLastMonth = sumLastMonth.sum_sale_part;
    this.sumTotalLastYear = sumLastMonth.sum_sale_years;

    this.diffMonth = this.sumTotalThisMonth - this.sumTotalLastMonth;
    this.diffYear = this.sumTotalThisYear - this.sumTotalLastYear;


    let yearDivice = 1;
    let monthDevice  = 1;

    if (this.sumTotalThisYear !== 10){
       yearDivice = this.sumTotalThisYear;
    }

    if (this.sumTotalThisMonth !== 0){
       monthDevice  =  this.sumTotalThisMonth;
    }

    this.monthPercen = (this.diffMonth / monthDevice) * 100;
    if (this.diffMonth < 0){
      this.monthPercen *= (-1);
    }

    this.yearPercen = (this.diffYear / yearDivice) * 100;
    if (this.diffYear < 0){
      this.yearPercen *= (-1);
    }
  }

  loadBestSaller(): void {
    this.api.get('/report/loadBestSaller').subscribe((res: any) => {
      this.bestSaler = res;
    });
  }

  loadLastBillSale(): void {
    this.api.get('/report/loadLastBillSale').subscribe((res) => {
      this.lastBillItem = res.bill_detail;
      this.inv_code = res.inv_code;
    });
  }

  loadDataSum(condition: any): void{
    this.drawDonutChart(this.cost, this.sum_profit);

    this.api.post(condition , '/report/loadDataSum').subscribe((res) => {
      this.sum_profit = res.sum_profit==undefined?0:res.sum_profit;
      this.sum_sale = res.sum_sale==undefined?0:res.sum_sale;
      this.sum_vat = res.sum_vat==undefined?0:res.sum_vat;
      this.cost = res.cost==undefined?0:res.cost;

      this.drawDonutChart(this.cost, this.sum_profit);
      this.profit_percen = (this.sum_profit / this.sum_sale) * 100;
      this.cost_percen = (this.cost / this.sum_sale) * 100;
    });

  }

  loadSumSalePerDay(): void {
      this.api.get('/report/loadSumSalePerDay').subscribe((res) => {
          this.graphData = res;
          
          // this.deawGraphChart(this.graphData)
          // this.drawLineChart(this.graphData)
          this.drawBarChartDay(this.graphData);
      });

  }

  loadDataPerDay(): void {
    this.api.get('/report/loadDataPerDay').subscribe((res) => {
      this.sumSale_today  = res.sum_sale;
      this.sumCost_today = res.cost;
      this.sumProfit_today = res.sum_profit;
      this.sumVat_today = res.sum_vat;
    });
  }

  loadSumSalePerMonth(): void {

      this.api.get('/report/loadSumSalePerMonth').subscribe((res) => {

          res[0].color = global.COLOR_RED;
          res[1].color = global.COLOR_ORANGE;
          res[2].color = global.COLOR_GREEN;
          res[3].color = global.COLOR_AQUA;
          res[4].color = global.COLOR_BLUE;
          res[5].color = global.COLOR_PURPLE;
          res[6].color = global.COLOR_GREY;
          res[7].color = global.COLOR_BLACK;
          res[8].color = global.COLOR_RED;
          res[9].color = global.COLOR_ORANGE;
          res[10].color = global.COLOR_GREEN;
          res[11].color = global.COLOR_AQUA;

          this.barData = res;
          this.drawBarChart(this.barData);
      });
  }

  drawDonutChart(cost: number|0, profit: number|0): void{

    this.donutChartOptions = {
      chart: {
        type: 'pieChart',
        height: 250,
        x(d){return d.label; },
        y(d){return d.value; },
        margin : { top: 10, right: 10, bottom: 10, left: 10 },
        showLegend: false,
        donut: true,
        growOnHover: false,
        arcsRadius: [
          { inner: 0.65, outer: 0.93 },
          { inner: 0.6, outer: 1 }
        ],
        duration: 300,
        donutRatio: 0.5
      }
    };

    this.donutChartData = [
      { label: 'ต้นทุน ' , value : cost, color: global.COLOR_GREEN },
      { label: 'กำไร '  , value : profit, color: global.COLOR_AQUA }
    ];
  }

  drawBarChartDay(data): void {

    this.stackedBarChartData = [{
      key: 'สรุปยอดขายรายวัน',
      color : global.COLOR_AQUA_DARKER,
      values: data
    }];

    this.stackedBarChartOptions = {
      chart: {
        type: 'multiBarChart',
        height: 350,
        stacked: true,
        showControls: false,
      }
    };
    nv.utils.windowResize(this.stackedBarChartOptions.update)

  }

  
  drawBarChart(barData): void {
    this.barChartMonthData = [{
      key: 'สรุปยอดขายรายเดือน',
      color : global.COLOR_AQUA_DARKER,
      values: barData
    }];

    this.barChartMonthOptions = {
      chart: {
        type: 'multiBarChart',
        height: 350,
        stacked: true,
        showControls: false,
      }
    };
    nv.utils.windowResize(this.barChartMonthOptions.update)

    // this.barChartOptions = {
    //   chart: {
    //     type: 'discreteBarChart',
    //     height: 300,
        
    //     // width: 10 ,
    //     x(d){return d.label; },
    //     y(d){return d.value; },
    //     showValues: true,
    //     duration: 1000,
    //     // yAxis: {
    //     //   axisLabel: 'Total Sales'
    //     // },
    //     xAxis: {
    //       axisLabel: 'เดือน'
    //     }
    //   }
    // };

    // nv.utils.windowResize(this.barChartOptions.update)
    // this.barChartData = [{
    //   key: 'Cumulative Return',
    //   values: barData
    // }];
  }


  // deawGraphChart(graphData) : void {

  //   this.stackedChartOptions = {
  //     chart: {
  //       type: 'stackedAreaChart',
  //       height: 300,
  //       useInteractiveGuideline: true,
  //       x: function(d){return d[0];},
  //       y: function(d){return d[1];},
  //       pointSize:20,
  //       margin : { top: 20, right: 25, bottom: 20, left: 60 },
  //       controlLabels: { stacked: 'Stacked' },
  //       showControls: false,
  //       duration: 1000,
  //       xAxis: {

  //       },
  //       yAxis: {
  //         tickFormat: function(d) {
  //           if (d == null) {
  //               return 'N/A';
  //           }
  //           return d3.format(',.2f')(d);
  //         }
  //       },

  //     }
  //   }

  //   this.stackedChartData = [{
  //     key: "ยอดขายรายวัน",
  //     color: global.COLOR_AQUA_DARKER,
  //     values: graphData
  //   }];
  // }




  // drawLineChart(data) : void {
  //   this.lineChartData = [
  //     { values: data, key: 'Sine Wave', color: global.COLOR_GREEN },
  //   ];

  //   this.lineChartOptions = {
  //     chart: {
  //       type: 'lineChart',
  //       height: 350,
  //       useInteractiveGuideline: true,
  //       xAxis: {
  //         axisLabel: 'วันที่',

  //       },
  //       yAxis: {
  //         axisLabel: 'Voltage (v)',
  //         tickFormat: function(d) {
  //             if (d == null) {
  //                 return 'N/A';
  //             }
  //             return d3.format(',.2f')(d);
  //         }
  //       }
  //     }
  //   }
  // }


}
